import request from '@/utils/request'

export const authApi = {
  changePassword: data => request.put('/auth/change-password', data)
}
